import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';

import BillingInfoForm, { BillingInfoFormProps } from '../BillingInfoForm';

export type BillingInfoBlockProps = BillingInfoFormProps & {};

const BillingInfoBlock: FC<BillingInfoBlockProps> = props => (
  <>
    <TitleBlock title="Billing info" size="medium" level={3} />
    <BillingInfoForm {...props} />
  </>
);

export default BillingInfoBlock;
